export default __webpack_public_path__ + "static/media/airtime.89e1556d.svg";